// Services page styles - Uses theme.palette.primary.main instead of hardcoded purple
import { alpha } from "@mui/material/styles";

export const getColors = (theme) => ({
  // Primary colors from theme
  primary: theme.palette.primary.main,
  primaryDark: theme.palette.primary.dark,
  primaryLight: theme.palette.primary.light,
  // Use MUI's alpha function for proper transparency
  primaryAlpha: (opacity) => alpha(theme.palette.primary.main, parseFloat(opacity) / 100),

  // Status colors
  success: "#10B981",
  successLight: "#ECFDF5",
  warning: "#F59E0B",
  warningLight: "#FFFBEB",
  danger: "#EF4444",
  dangerLight: "#FEF2F2",
  info: "#3B82F6",
  infoLight: "#EFF6FF",

  // Backgrounds
  bgPrimary: "#F8FAFC",
  bgCard: "#FFFFFF",
  bgHover: "#F1F5F9",

  // Text
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",

  // Borders
  border: "#E2E8F0",
  borderLight: "#E2E8F0",

  // Chart colors - Using primary with variations
  chartPrimary: theme.palette.primary.main,
  chartPrimaryLight: theme.palette.primary.light,
  chartGreen: "#10B981",
  chartOrange: "#F59E0B",
  chartBlue: "#3B82F6",
});

export const shadows = {
  card: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)",
  cardHover: "0 10px 15px rgba(0, 0, 0, 0.1), 0 4px 6px rgba(0, 0, 0, 0.05)",
  dropdown: "0 10px 40px rgba(0, 0, 0, 0.15)",
};

export const getServiceIcon = (service) => {
  const iconMap = {
    skin: { color: "#3B82F6", bg: "#EFF6FF", emoji: "✨" },
    dental: { color: "#8B5CF6", bg: "#F5F3FF", emoji: "🦷" },
    hair: { color: "#10B981", bg: "#ECFDF5", emoji: "💇" },
    wellness: { color: "#F59E0B", bg: "#FFFBEB", emoji: "🧘" },
  };

  return iconMap[service?.toLowerCase()] || { color: "#64748B", bg: "#F8FAFC", emoji: "🏥" };
};
